import React, {useState} from "react"
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Input from "@amzn/meridian/input";
import Text from "@amzn/meridian/text";

const RemittanceSection = ({onRemittanceCodeChange, onConfirmRemittanceCodeChange}) => {
    const [remittanceCode, setRemittanceCode] = useState();
    const [confirmedRemittanceCode, setConfirmedRemittanceCode] = useState();

    const handleRemittanceCodeChange = event => {
        setRemittanceCode(event);
        onRemittanceCodeChange(event);
    }

    const handleConfirmedRemittanceCodeChange = event => {
        setConfirmedRemittanceCode(event);
        onConfirmRemittanceCodeChange(event);
    }

    return (
        <Box>
            <Row width="100%">
                    <Box spacingInset="small none">
                        <Row>
                            <Text type="h200">Deposit Code</Text>
                        </Row>
                        <Row>
                        <Text color="secondary" type="b200">Enter the deposit code. Refer <a href="https://w.amazon.com/bin/view/DeliveryStationTech/Inbound/COD/SCCDepositCodeFormat" target="_blank" rel="noopener noreferrer">here</a> for the Deposit Code format for each country</Text>
                        </Row>
                    </Box>
            </Row>
            <Column>
                <Row width="100%" widths="grid-8">
                    <Input
                        placeholder="Deposit Code"
                        size="xlarge"
                        value={remittanceCode}
                        onChange={handleRemittanceCodeChange}
                        error={remittanceCode === ""}
                    />
                </Row>
                <Row width="100%" widths="grid-8">
                    <Input
                        placeholder="Confirm Deposit Code"
                        size="xlarge"
                        value={confirmedRemittanceCode}
                        onChange={handleConfirmedRemittanceCodeChange}
                    />
                </Row>
            </Column>
        </Box>
    );
}

export default RemittanceSection;



// WEBPACK FOOTER //
// ./src/component/modal/deposit/remittanceSection.js